// NEW: UI_REVAMP
import { Text } from '@chakra-ui/react';

const HotNumberText = ({ isSelected, isHot, num, ...props }) => {
	return (
		<Text
			fontSize={{ base: '18px', lg: '22px' }}
			fontWeight={isSelected ? 700 : 600}
			color={isHot ? undefined : 'inherit'}
			bgGradient={isHot ? 'linear-gradient(180deg, #D81985 0%, #E81A1E 100%)' : undefined}
			bgClip={isHot ? 'text' : undefined}
			sx={{
				WebkitBackgroundClip: isHot ? 'text' : undefined,
				WebkitTextFillColor: isHot ? 'transparent' : undefined,
			}}
			textShadow={isHot ? '#FFF 1px 0 10px ' : 'none'}
			{...props}
		>
			{num}
		</Text>
	);
};

export default HotNumberText;
